module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_f_piebald.32f009c5.png";